import React from "react";

function TableRow({ index, member }) {
  return (
    <tr>
      <th scope="row">{index + 1}</th>
      <td>{member.name}</td>
      <td>{member.mobile}</td>
      <td>{member?.blood}</td>
      <td>{member.institution}</td>
      <td>{member.department}</td>
      <td>{member.village}</td>
      <td>{member.hsc}</td>
    </tr>
  );
}

export default TableRow;
